import React from 'react';
import { token } from '@atlaskit/tokens';
import type { Point } from '../../../common/types/diagram.tsx';

interface Props {
	start: Point;
	end: Point;
}

const ProposedTransition = ({ start, end }: Props) => (
	<line
		x1={start.x}
		y1={start.y}
		x2={end.x}
		y2={end.y}
		strokeDasharray="4"
		stroke={token('color.border.accent.blue')}
		pointerEvents="none"
	/>
);

export default ProposedTransition;
